import PropTypes from 'prop-types';
import React from 'react';
import { useRouter } from 'next/router';
import FAQNav from './faq-nav';
import { FAQ as FAQRouteConstants } from '../../route-constants';
import './faq-layout.less';

/**
 * FAQ Layout Page
 * Renders an FAQNav as a sidebar and a main content area.
 */
const FAQLayout = ({ children, faqSectionList }) => {
  const { topic } = useRouter().query;
  const currentRoute = `${FAQRouteConstants.BASE_URI}/${topic}`;
  const links = faqSectionList.map((section) => {
    const route = `${FAQRouteConstants.BASE_URI}/${section.slug}`;
    return {
      route,
      text: section.title,
      active: route === currentRoute,
    };
  });

  return (
    <div className='FAQLayout'>
      <div className='nav'>
        <FAQNav
          links={links}
          currentRoute={currentRoute} />
      </div>
      <div className='content'>
        {children}
      </div>
    </div>
  );
};

FAQLayout.propTypes = {
  faqSectionList: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
    questions: PropTypes.array,
  })),
  children: PropTypes.node,
};

FAQLayout.defaultProps = {
  faqSectionList: [],
  children: null,
};

export default FAQLayout;
